export const PITI_LABEL = 'PITI';

export const PITI_PENDING_CHANGES_KEY = 'Piti';

export const rows = [
  {
    label: 'First Mortgage (P&I)',
    valueKey: 'principalAndInterest',
    pendingChangesKey: 'PrincipalAndInterest',
    checkIsHidden: isSubordinateLien => !isSubordinateLien,
  },
  {
    label: 'Subordinate Lien(s) (P&I)',
    valueKey: 'secondMortgagePrincipalAndInterest',
    pendingChangesKey: 'SecondMortgagePrincipalAndInterest',
    checkIsHidden: isSubordinateLien => !isSubordinateLien,
  },
  {
    label: 'Principal & Interest',
    valueKey: 'principalAndInterest',
    pendingChangesKey: 'PrincipalAndInterest',
    checkIsHidden: isSubordinateLien => isSubordinateLien,
  },
  {
    label: 'Property Taxes',
    valueKey: 'propertyTaxes',
    pendingChangesKey: 'PropertyTaxes',
  },
  {
    label: 'Mortgage Insurance',
    valueKey: 'mortgageInsurance',
    pendingChangesKey: 'MortgageInsurance',
  },
  {
    label: 'Homeowners Insurance',
    valueKey: 'homeownersInsurance',
    pendingChangesKey: 'HomeownersInsurance',
  },
  {
    label: 'HOA Dues',
    valueKey: 'homeownersAssociation',
    pendingChangesKey: 'HomeownersAssociation',
  },
  {
    label: 'Supplemental Insurance',
    valueKey: 'supplementalInsurance',
  },
  {
    label: 'Other Expenses',
    valueKey: 'otherExpenses',
  },
];
